import React from "react";
import { Field } from "react-final-form";
import { TextFieldAdapter } from "@soqs/common";
const isAddress = (name) => {
  //Latin-1 without Appendix E
  const re = /^[ "&-.0-:A-Za-z:0-9]{1,24}$/;
  return name && re.test(name)
    ? undefined
    : name === undefined || name?.length === 0
    ? "A valid City must be provided"
    : "A valid City must be provided";
};

const AddressCity = ({ ...rest }) => (
  <Field
    name="addresscity"
    validate={isAddress}
    label="Address"
    autoComplete=""
    component={TextFieldAdapter}
    subscription={{ touched: true, value: true, error: true }}
    fullWidth
    inputProps={{ maxLength: 24 }}
    {...rest}
  />
);

export default AddressCity;
